<template>
  <div class="pages">
    <div class="topBg" :style="{ paddingTop: 35 + statusBarHeight + 'px' }">
      <div class="header">
        <!-- <Back
        :clickHandle="handleClosePage"
        :innerText="localesPackage?.['yuli_back']?.[localesEnv]"
      /> -->
        <div class="back" @click="handlePageClose"></div>

        <div class="rules" @click="handleToRules">
          <img
            :src="require(`@/assets/images/YuliApp/YuliStaking/rules.png`)"
          />
        </div>
      </div>
      <div class="centerView">
        <div class="top">
          <div class="title">Gen2 Yuli Stake</div>
          <div class="desc">Stake to Earn Passcard and $ART!</div>
        </div>
        <div class="bottom">
          <div
            class="tag"
            :class="{
              active: currentTab == item,
              dot: showRedList.includes(item),
            }"
            v-for="(item, index) in swithc_group"
            :key="index"
            @click="handleTabClick(item)"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </div>

    <div class="content" id="staking_content">
      <div v-if="currentTab === 'Staking'">
        <Staking />
      </div>
      <div v-if="currentTab === 'My Staking'">
        <MyStaking @onRedDot="handleMyStakingRedDot" />
      </div>
    </div>

    <StakingRules @onClose="handleRuleClose" v-if="isRulesShow" />
  </div>
</template>

<script>
import { STKAKING, MYSTAKING, SWITCH_GROUP } from "./constants/constants.js";
import { mapState } from "vuex";
import { onBeforeMount, onMounted, ref } from "vue";
import appBridging from "@/utils/appBridging.js";
import store from "@/store";
// import Back from "@/components/universal/Back";
import Staking from "./components/Staking";
import MyStaking from "./components/MyStaking";
import StakingRules from "./components/StakingRules";
import { getYOG2StakingRecord, getYuliList } from "@/api/staking.js";

export default {
  components: {
    // Back,
    Staking,
    MyStaking,
    StakingRules,
  },
  computed: {
    ...mapState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  watch: {
    init: {
      async handler(value) {
        if (value) {
          this.handleInit();
        }
      },
      immediate: true,
      deep: true,
    },
    languageEnv: {
      async handler(value) {
        if (value) {
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if (value) {
          this.localesPackage = value;
          // this.handlePageinit();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  setup() {
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref("en");

    const swithc_group = ref([]);
    const currentTab = ref(STKAKING);
    const showRedList = ref([]);

    const isRulesShow = ref(false);

    onBeforeMount(async () => {
      appBridging.getSettingLaungage();
    });

    onMounted(() => {
      swithc_group.value = SWITCH_GROUP;
    });

    const handleInit = () => {
      appBridging.getStatusBarHeight();

      handlePageinit();

      handleInitStakingRecord();
    };

    /**
     * 页面初始化
     */
    const handlePageinit = () => {
      const localesPackageLocal = localesPackage.value;
      const localesEnvLocal = localesEnv.value;

      appBridging.closeLoading();
    };

    /**
     * 关闭页面
     */
    const handlePageClose = () => {
      appBridging.closePage();
    };

    /**
     * 处理Tab点击
     */
    const handleTabClick = (item) => {
      if (item === currentTab.value) return;

      currentTab.value = item;
    };

    /**
     * 跳转至规则页
     */
    const handleToRules = () => {
      // window.open(
      //   "https://iodized-bug-97c.notion.site/Yuliverse-Yuli-Gen2-Staking-Guide-2283ef488d6541b79402a385ba1dcce1"
      // );

      isRulesShow.value = true;
    };

    const handleRuleClose = () => {
      isRulesShow.value = false;
    };

    /**
     * 处理加载列表
     */
    const handleInitStakingRecord = async () => {
      const res = await getYOG2StakingRecord({});
      const _list = res?.data || [];

      // 红点通知
      const isNeedRedeem = _list?.some((item) => {
        const extension = item?.extension;
        const end_time = item?.end_time || extension?.end_time || 0;
        const nowaday = new Date().getTime();
        const isStakingOver = nowaday > end_time * 1000;

        const redeem_at = item?.redeem_at || extension?.redeem_at || "";
        const is_redeem = item?.is_redeem || false;
        const isRedeem = redeem_at || is_redeem;

        return isStakingOver && !isRedeem;
      });

      handleMyStakingRedDot(isNeedRedeem);
    };

    /**
     * 处理MyStaking红点展示
     */
    const handleMyStakingRedDot = (isShow) => {
      const _list = [...showRedList.value];
      const _index = _list.indexOf("My Staking");

      if (isShow && _index === -1) {
        _list.push("My Staking");
      }

      if (!isShow && _index !== -1) {
        _list.splice(_index, 1);
      }

      showRedList.value = [..._list];
    };

    return {
      localesPackage,
      localesEnv,
      swithc_group,
      currentTab,
      showRedList,
      handlePageinit,
      handlePageClose,
      handleTabClick,
      handleToRules,
      handleMyStakingRedDot,
      isRulesShow,
      handleRuleClose,
      handleInit,
    };
  },
};
</script>

<style lang="less" scoped>
.pages {
  width: 100%;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  position: relative;
  // background-color: #12426d;
  background-color: #0f193b;
  overflow-x: hidden;
  overflow: hidden;

  .topBg {
    width: 100%;
    height: 249px;
    background-image: url("~@/assets/images/YuliApp/YuliStaking/banner_2.png");
    background-position: center;
    background-size: cover;
    position: relative;
    border-bottom: 3px solid #57ffeb;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;

    .header {
      width: 100%;
      height: 30px;
      z-index: 1;
      display: flex;
      flex-direction: row;
      align-content: center;
      justify-content: space-between;
      margin-top: 6px;

      .back {
        width: 55px;
        height: 30px;
        background-image: url("~@/assets/images/YuliApp/YuliStaking/icon_back.png");
        background-size: 100% 100%;
        background-position: center;
      }

      .rules {
        width: 65px;
        height: 25px;
        color: #0f193b;
        font-size: 12px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 65px;
        height: 25px;
        // cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .centerView {
      flex: 1;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      text-align: center;

      .top {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        margin-top: 8px;

        .title {
          @shadowColor: #001752;
          @shadowR: 2px;
          text-shadow: 0 1px @shadowR @shadowColor, 1px 0 @shadowR @shadowColor,
            -1px 0 @shadowR @shadowColor, 0 -1px @shadowR @shadowColor;
          font-family: "Tomorrow";
          font-size: 30px;
          font-weight: 700;
          margin-bottom: 7px;
        }

        .desc {
          @shadowColor: #001752;
          @shadowR: 1px;
          text-shadow: 0 1px @shadowR @shadowColor, 1px 0 @shadowR @shadowColor,
            -1px 0 @shadowR @shadowColor, 0 -1px @shadowR @shadowColor;
          font-family: "Inter";
          font-size: 18px;
          font-weight: 500;
        }
      }

      .bottom {
        width: 331px;
        position: absolute;
        left: 0;
        bottom: -1px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        left: 50%;
        transform: translateX(-50%);

        .tag {
          width: 162px;
          height: 37px;
          background-image: url("~@/assets/images/YuliApp/YuliStaking/switchItemOff.png");
          background-size: 100% 100%;
          color: #00b59f;
          font-family: "Tomorrow";
          font-size: 16px;
          font-weight: 500;
          display: flex;
          align-items: center;
          justify-content: center;
          // cursor: pointer;
        }

        .active {
          background-image: url("~@/assets/images/YuliApp/YuliStaking/switchItemOn.png");
          background-size: 100% 100%;
          color: #0f193b;
        }

        .dot {
          &::after {
            content: " ";
            width: 16px;
            height: 16px;
            background-image: url("~@/assets/images/YuliApp/YuliStaking/icon_dot.png");
            background-size: 100% 100%;
            background-position: center;
            background-repeat: no-repeat;
            position: absolute;
            top: -4px;
            right: -4px;
          }
        }
      }
    }
  }

  .content {
    flex: 1;
    width: 100%;
    max-width: 790px;
    // min-height: 200px;
    // padding-bottom: 70px;
    overflow: scroll;
    display: flex;
    flex-direction: column;
  }
}
</style>
